import "./OurProducts.css";
import { useState } from "react";
import {
  FaSearch,
  FaShoppingCart,
  FaStar,
  FaArrowRight,
  FaWhatsapp,
  FaHeart
} from "react-icons/fa";

function OurProducts() {

  const products = [

    {
      id: 1,
      name: "CenturyPly Club Prime",
      category: "Plywood",
      brand: "CenturyPly",
      price: "₹3,450",
      rating: 5,
      image:
        "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=900"
    },

    {
      id: 2,
      name: "Greenply Ecotec",
      category: "Plywood",
      brand: "Greenply",
      price: "₹2,980",
      rating: 4.8,
      image:
        "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=900"
    },

    {
      id: 3,
      name: "Century Laminates",
      category: "Laminate",
      brand: "Century",
      price: "₹1,450",
      rating: 4.7,
      image:
        "https://images.unsplash.com/photo-1484101403633-562f891dc89a?w=900"
    },

    {
      id: 4,
      name: "Green MDF Board",
      category: "MDF",
      brand: "GreenPanel",
      price: "₹1,980",
      rating: 4.9,
      image:
        "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=900"
    },

    {
      id: 5,
      name: "Decor Veneer",
      category: "Veneer",
      brand: "Decor",
      price: "₹2,150",
      rating: 4.8,
      image:
        "https://images.unsplash.com/photo-1460317442991-0ec209397118?w=900"
    },

    {
      id: 6,
      name: "Fevicol Marine",
      category: "Adhesive",
      brand: "Pidilite",
      price: "₹690",
      rating: 5,
      image:
        "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=900"
    },

    {
  id: 7,
  name: "Merino Laminates Premium",
  category: "Laminate",
  brand: "Merino",
  price: "₹1,680",
  rating: 4.8,
  image: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=900"
},

{
  id: 8,
  name: "Action TESA MDF",
  category: "MDF",
  brand: "Action TESA",
  price: "₹2,250",
  rating: 4.9,
  image: "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=900"
},

{
  id: 9,
  name: "Green Decorative Veneer",
  category: "Veneer",
  brand: "Greenlam",
  price: "₹2,890",
  rating: 4.7,
  image: "https://images.unsplash.com/photo-1460317442991-0ec209397118?w=900"
},

{
  id: 10,
  name: "Hettich Drawer Channel",
  category: "Hardware",
  brand: "Hettich",
  price: "₹950",
  rating: 5,
  image: "https://images.unsplash.com/photo-1484101403633-562f891dc89a?w=900"
},

{
  id: 11,
  name: "Ebco Hinges Set",
  category: "Hardware",
  brand: "Ebco",
  price: "₹420",
  rating: 4.6,
  image: "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=900"
},

{
  id: 12,
  name: "Fevicol SH",
  category: "Adhesive",
  brand: "Pidilite",
  price: "₹180",
  rating: 4.9,
  image: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=900"
},

{
  id: 13,
  name: "Century Club Prime 710",
  category: "Plywood",
  brand: "CenturyPly",
  price: "₹3,980",
  rating: 5,
  image:
    "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=900"
},

{
  id: 14,
  name: "Green Club 700",
  category: "Plywood",
  brand: "Greenply",
  price: "₹3,550",
  rating: 4.8,
  image:
    "https://images.unsplash.com/photo-1484101403633-562f891dc89a?w=900"
},

{
  id: 15,
  name: "Advance Decorative Laminate",
  category: "Laminate",
  brand: "Advance",
  price: "₹1,350",
  rating: 4.7,
  image:
    "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=900"
},

{
  id: 16,
  name: "Century MDF Interior",
  category: "MDF",
  brand: "Century",
  price: "₹2,180",
  rating: 4.8,
  image:
    "https://images.unsplash.com/photo-1460317442991-0ec209397118?w=900"
},

{
  id: 17,
  name: "Royal Teak Veneer",
  category: "Veneer",
  brand: "Royal",
  price: "₹2,990",
  rating: 4.9,
  image:
    "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=900"
},

{
  id: 18,
  name: "Godrej Door Lock",
  category: "Hardware",
  brand: "Godrej",
  price: "₹1,250",
  rating: 4.8,
  image:
    "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=900"
},

{
  id: 19,
  name: "Pidilite Marine Adhesive",
  category: "Adhesive",
  brand: "Pidilite",
  price: "₹540",
  rating: 5,
  image:
    "https://images.unsplash.com/photo-1484101403633-562f891dc89a?w=900"
},

{
  id: 20,
  name: "Imported Designer Laminate",
  category: "Laminate",
  brand: "Merino",
  price: "₹1,990",
  rating: 4.9,
  image:
    "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=900"
}

  ];

  const [search, setSearch] = useState("");

  const filteredProducts = products.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()) ||
    item.category.toLowerCase().includes(search.toLowerCase()) ||
    item.brand.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
          <section className="products-hero">

        <div className="products-overlay">

          <h1>
            Our Products
          </h1>

          <p>
            Explore Premium Quality Plywood,
            Laminates, MDF, Veneers,
            Hardware & Interior Products.
          </p>

          <div className="products-search">

            <FaSearch />

            <input
              type="text"
              placeholder="Search Products..."
              value={search}
              onChange={(e)=>setSearch(e.target.value)}
            />

          </div>

        </div>

      </section>
      <section className="product-category-section">

<h2>
Product Categories
</h2>

<div className="product-category-grid">

<div className="product-category-card">
Plywood
</div>

<div className="product-category-card">
Laminates
</div>

<div className="product-category-card">
MDF Boards
</div>

<div className="product-category-card">
Veneers
</div>

<div className="product-category-card">
Hardware
</div>

<div className="product-category-card">
Adhesives
</div>

</div>

</section>

<section className="products-section">

<h2>
Featured Products
</h2>

<div className="products-grid">

{

filteredProducts.map((item)=>(

<div
className="product-card"
key={item.id}
>

<div className="product-image">

<div className="product-badge">
Best Seller
</div>

<div className="wishlist-icon">
<FaHeart/>
</div>

<img
src={item.image}
alt={item.name}
/>

</div>

<div className="product-content">

<h3>
{item.name}
</h3>

<p>
{item.category}
</p>

<h4>
{item.brand}
</h4>

<div className="rating">

<FaStar/>

<FaStar/>

<FaStar/>

<FaStar/>

<FaStar/>

<span>
{item.rating}
</span>

</div>

<h2>
{item.price}
</h2>

<div className="product-buttons">

<button
className="whatsapp-btn"
onClick={() =>
window.open(
"https://wa.me/919876543210",
"_blank"
)
}
>

<FaWhatsapp/>

WhatsApp

</button>

<button
className="details-btn"
>

View Details

<FaArrowRight/>

</button>

</div>

</div>

</div>

))

}

</div>

</section>

    </>
  );
}

export default OurProducts;